import { ToastPosition } from 'react-toastify';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

const parseNumber = (value: string | undefined, defaultValue: number): number => {
    if (value === undefined) return defaultValue;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? defaultValue : parsed;
};

const parsePosition = (value: string | undefined, defaultValue: ToastPosition): ToastPosition => {
    if (value === undefined) return defaultValue;
    const validPositions = ['top-left', 'top-right', 'top-center', 'bottom-left', 'bottom-right', 'bottom-center'];
    return validPositions.includes(value) ? (value as ToastPosition) : defaultValue;
};

const defaultPosition = parsePosition(import.meta.env.VITE_NOTIFICATION_POSITION, 'bottom-center');
const defaultDuration = parseNumber(import.meta.env.VITE_NOTIFICATION_DURATION, 4000);

export const NOTIFICATION_CONFIG = {
    notification: {
        position: {
            error: defaultPosition,
            success: defaultPosition,
            warning: defaultPosition,
            info: defaultPosition
        },
        duration: {
            error: defaultDuration,
            success: defaultDuration,
            warning: defaultDuration,
            info: defaultDuration
        },
        closeButton: false,
        hideProgressBar: false,
        draggable: false,
        closeOnClick: true,
        pauseOnHover: true,
        pauseOnFocusLoss: true,
        maxToasts: 5
    }
} as const;
